import { PreviewContext } from "./contexts";

/**
 * Wraps the Subject with the PreviewContext using the `preview` value extracted from the props
 *
 * @param Component react.ReactNode
 * @returns react.ReactNode
 */
export const withPreviewFromProps = (Component) => {
    return (props) => {
        const { preview } = props;

        return (
            <>
                <PreviewContext.Provider value={{ preview }}>
                    <Component {...props} />
                </PreviewContext.Provider>
            </>
        );
    };
};
